import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { uniqueId } from 'lodash';
import { fetchIncome } from '../../actions/reportActions';
import { fnum } from '../../utils/utils'

class Income extends React.Component{

  state = {
    filter: {
      from: (
        (
          localStorage.incomeFilter &&
          JSON.parse(localStorage.incomeFilter).from
        ) || moment().subtract(6, "months").format('Y-MM-DD')
      ),
      to: (
        (
          localStorage.incomeFilter &&
          JSON.parse(localStorage.incomeFilter).to
        ) || moment().add(1, "months").format('Y-MM-DD')
      )
    }
  }

  componentWillMount(){
    this.refreshData();
  }

  refreshData = () => {
    const { from, to } = this.state.filter;
    this.props.fetchIncome(from, to);
  }

  handleFilterDate = (e, field) => {
    const filter = {
      ...this.state.filter,
      [field]: e.format('Y-MM-DD')
    };
    this.setState({filter});
    localStorage.incomeFilter = JSON.stringify(filter);
  }

  render() {
    const { data, fields, sums } = this.props.income;
    const { from, to } = this.state.filter;

    return (
      <div>
        <h1>Чистая прибыль</h1>
        <div className="form-group form-inline">
          <div style={{display:'inline-block'}}>
            <DatePicker
              className="form-control"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              selected={moment(from)}
              selectsStart
              startDate={moment(from)}
              endDate={moment(to)}
              onChange={(e) => this.handleFilterDate(e, 'from')}
            />
          </div>{" - "}
          <div style={{display:'inline-block'}}>
            <DatePicker
              className="form-control"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              selected={moment(to)}
              selectsStart
              startDate={moment(from)}
              endDate={moment(to)}
              onChange={(e) => this.handleFilterDate(e, 'to')}
            />
          </div>{" "}
          <button className="btn btn-success" onClick={this.refreshData}>
            Обновить
          </button>
        </div>
        {(data && data.length) ? (
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Месяц</th>
                {data.map(rec => (
                  <th key={rec['date']} className="text-right">{rec['date']}</th>
                ))}
                <th className="text-right">Сумма</th>
              </tr>
            </thead>
            <tbody>
              {fields.map(field => (
                <tr key={field.value}>
                  <td>{field.label}</td>
                  {data.map(rec => (
                    <td key={uniqueId()} className="text-right">
                      {fnum(rec[field.value])}
                    </td>
                  ))}
                  <td className="text-right">{fnum(sums[field.value])}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div>Загрузка данных...</div>
        )}
      </div>
    );
  }
}

function mapOrdersToProps(store){
  return {
    income: store.reports.income
  }
}

export default connect(mapOrdersToProps, { fetchIncome })(Income);



// WEBPACK FOOTER //
// ./src/components/reports/Income.js